
import { Vue, Component } from 'vue-property-decorator'
import Subelement from '@/types/subelement'
import Column from '@/types/column'
import axios from 'axios'
import Option from '@/types/option'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class SubelementEditOptionsTab extends Vue {
  settings = {
    routeNames: { list: 'subelements', show: 'subelementShow', edit: 'subelementEdit' },
    routeParamKey: 'subelementId',
    functionNames: { setCurrent: 'setCurrentSubelement', save: 'saveSubelement' },
    getterNames: { current: 'currentSubelement', loading: 'loadingSubelement', errors: 'subelementErrors' }
  }

  columns:Column[] = [
    {
      title: 'Optie nr.',
      key: 'external_ref',
      dataIndex: 'external_ref',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Naam',
      key: 'name',
      dataIndex: 'name',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Commerciële naam',
      key: 'name_sales',
      dataIndex: 'name_sales',
      filters: [],
      sorter: false,
      sortDirections: ['ascend', 'descend']
    },
    {
      title: 'Actie\'s',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  option = null
  showAddModal = false
  searchTimer = 0
  options:Option[] = []

  showAddOptionModal () : void {
    this.showAddModal = true
  }

  hideAddOptionModal () : void {
    this.showAddModal = false
    this.option = null
  }

  getOptionDetails (id:number) : void {
    axios.get(process.env.VUE_APP_API_URL + '/options/' + id).then((res) => {
      this.option = res.data.data
    })
  }

  addOption () : void {
    this.$store.dispatch('optionAddedToSubelement', this.option)
    this.hideAddOptionModal()
  }

  deleteOption (id:number) : void {
    this.$store.dispatch('optionDeletedFromSubelement', id)
  }

  searchOption (val:string) : void {
    if (val.length >= 3) {
      clearTimeout(this.searchTimer)

      this.searchTimer = setTimeout(() => {
        axios.get(process.env.VUE_APP_API_URL + '/options?filter[search]=' + val).then((res) => {
          this.options = res.data.data
        })
      }, 500)
    }
  }

  onRowClick (rowData:{id:number}) : { on: { click: () => void }} {
    return {
      on: {
        click: () => {
          const keyboard = window.event as KeyboardEvent
          if (can('options.edit')) {
            const route = this.$router.resolve({ name: 'optionEdit', params: { optionId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          } else if (can('options.view')) {
            const route = this.$router.resolve({ name: 'optionShow', params: { optionId: rowData.id.toString() } })
            window.open(route.href, keyboard.ctrlKey ? '_blank' : '_self')
          }
        }
      }
    }
  }

  get currentItem () : Subelement {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
